"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _upgradeProducts = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/upgradeProducts");

var links = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/navigation/links"));

var _campaigns = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/campaigns");

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _GENERAL$SALES_PRO$SA;

var SALES_PRO = _upgradeProducts.upgradeProducts.SALES_PRO,
    SALES_FREE = _upgradeProducts.upgradeProducts.SALES_FREE,
    SALES_STARTER = _upgradeProducts.upgradeProducts.SALES_STARTER,
    SALES_PROFESSIONAL = _upgradeProducts.upgradeProducts.SALES_PROFESSIONAL,
    SALES_ENTERPRISE = _upgradeProducts.upgradeProducts.SALES_ENTERPRISE,
    MARKETING_FREE = _upgradeProducts.upgradeProducts.MARKETING_FREE,
    MARKETING_STARTER = _upgradeProducts.upgradeProducts.MARKETING_STARTER,
    MARKETING_STARTER_EMAIL = _upgradeProducts.upgradeProducts.MARKETING_STARTER_EMAIL,
    MARKETING_BASIC = _upgradeProducts.upgradeProducts.MARKETING_BASIC,
    MARKETING_PRO = _upgradeProducts.upgradeProducts.MARKETING_PRO,
    MARKETING_ENTERPRISE = _upgradeProducts.upgradeProducts.MARKETING_ENTERPRISE,
    SERVICE_FREE = _upgradeProducts.upgradeProducts.SERVICE_FREE,
    SERVICE_STARTER = _upgradeProducts.upgradeProducts.SERVICE_STARTER,
    SERVICE_PROFESSIONAL = _upgradeProducts.upgradeProducts.SERVICE_PROFESSIONAL,
    SERVICE_ENTERPRISE = _upgradeProducts.upgradeProducts.SERVICE_ENTERPRISE,
    STARTER_CONTACTS = _upgradeProducts.upgradeProducts.STARTER_CONTACTS,
    ADS = _upgradeProducts.upgradeProducts.ADS,
    ADS_CAPACITY = _upgradeProducts.upgradeProducts.ADS_CAPACITY,
    WEBSITE = _upgradeProducts.upgradeProducts.WEBSITE,
    REPORTING = _upgradeProducts.upgradeProducts.REPORTING,
    DEDICATED_IP = _upgradeProducts.upgradeProducts.DEDICATED_IP,
    TRANSACTIONAL_EMAIL = _upgradeProducts.upgradeProducts.TRANSACTIONAL_EMAIL,
    ADDITIONAL_ACCOUNT = _upgradeProducts.upgradeProducts.ADDITIONAL_ACCOUNT,
    BRAND_DOMAIN = _upgradeProducts.upgradeProducts.BRAND_DOMAIN,
    DESIGNATED_TECHNICAL_SUPPORT = _upgradeProducts.upgradeProducts.DESIGNATED_TECHNICAL_SUPPORT,
    IN_PERSON_TRAINING = _upgradeProducts.upgradeProducts.IN_PERSON_TRAINING,
    STARTER_KIT = _upgradeProducts.upgradeProducts.STARTER_KIT,
    QUICK_START_CONSULTATION = _upgradeProducts.upgradeProducts.QUICK_START_CONSULTATION,
    SALES_PROFESSIONAL_ONBOARDING = _upgradeProducts.upgradeProducts.SALES_PROFESSIONAL_ONBOARDING,
    SERVICE_PROFESSIONAL_ONBOARDING = _upgradeProducts.upgradeProducts.SERVICE_PROFESSIONAL_ONBOARDING,
    INBOUND_CONSULTING_BLOCK = _upgradeProducts.upgradeProducts.INBOUND_CONSULTING_BLOCK,
    TECHNICAL_CONSULTING_BLOCK = _upgradeProducts.upgradeProducts.TECHNICAL_CONSULTING_BLOCK,
    GENERAL = _upgradeProducts.upgradeProducts.GENERAL,
    CRM = _upgradeProducts.upgradeProducts.CRM,
    CMS = _upgradeProducts.upgradeProducts.CMS,
    ENTERPRISE_TRIAL = _upgradeProducts.upgradeProducts.ENTERPRISE_TRIAL,
    ENTERPRISE = _upgradeProducts.upgradeProducts.ENTERPRISE,
    PARTNER_PROGRAM = _upgradeProducts.upgradeProducts.PARTNER_PROGRAM,
    SUITE_STARTER = _upgradeProducts.upgradeProducts.SUITE_STARTER,
    SUITE_PROFESSIONAL = _upgradeProducts.upgradeProducts.SUITE_PROFESSIONAL,
    SUITE_ENTERPRISE = _upgradeProducts.upgradeProducts.SUITE_ENTERPRISE,
    BUNDLE = _upgradeProducts.upgradeProducts.BUNDLE;

var _default = (_GENERAL$SALES_PRO$SA = {}, (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, GENERAL, {
  campaign: _campaigns.campaigns[GENERAL],
  upgradeLink: links.productsAndAddons,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_PRO, {
  campaign: _campaigns.campaigns[SALES_PRO],
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_PRO_LEGACY
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_FREE, {
  campaign: _campaigns.campaigns[SALES_FREE],
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_FREE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_STARTER, {
  campaign: _campaigns.campaigns[SALES_STARTER],
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_STARTER
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_PROFESSIONAL, {
  campaign: _campaigns.campaigns[SALES_PROFESSIONAL],
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_PROFESSIONAL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_ENTERPRISE, {
  campaign: _campaigns.campaigns[SALES_ENTERPRISE],
  upgradeLink: links.salesPricing,
  merchandiseId: MerchandiseIds.PRODUCT_SALES_ENTERPRISE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_FREE, {
  campaign: _campaigns.campaigns[MARKETING_FREE],
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_FREE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_STARTER, {
  campaign: _campaigns.campaigns[MARKETING_STARTER],
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_STARTER_EMAIL, {
  campaign: _campaigns.campaigns[MARKETING_STARTER_EMAIL],
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_BASIC, {
  campaign: _campaigns.campaigns[MARKETING_BASIC],
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_BASIC
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_PRO, {
  campaign: _campaigns.campaigns[MARKETING_PRO],
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, MARKETING_ENTERPRISE, {
  campaign: _campaigns.campaigns[MARKETING_ENTERPRISE],
  upgradeLink: links.marketingPricing,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE,
  trialDuration: 30
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_FREE, {
  campaign: _campaigns.campaigns[SERVICE_FREE],
  upgradeLink: links.servicePricing,
  merchandiseId: MerchandiseIds.PRODUCT_SERVICE_FREE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_STARTER, {
  campaign: _campaigns.campaigns[SERVICE_STARTER],
  upgradeLink: links.servicePricing,
  merchandiseId: MerchandiseIds.PRODUCT_SERVICE_STARTER
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_PROFESSIONAL, {
  campaign: _campaigns.campaigns[SERVICE_PROFESSIONAL],
  upgradeLink: links.servicePricing,
  merchandiseId: MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_ENTERPRISE, {
  campaign: _campaigns.campaigns[SERVICE_ENTERPRISE],
  upgradeLink: links.servicePricing,
  merchandiseId: MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ENTERPRISE_TRIAL, {
  shouldSeePricingPage: true,
  canTalkToSales: true,
  campaign: _campaigns.campaigns[ENTERPRISE_TRIAL],
  upgradeLink: links.marketingPricing,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, STARTER_CONTACTS, {
  campaign: _campaigns.campaigns[STARTER_CONTACTS],
  upgradeLink: links.starterContacts,
  merchandiseId: MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ADS, {
  campaign: _campaigns.campaigns[ADS],
  upgradeLink: links.addonAds,
  merchandiseId: MerchandiseIds.ADDON_ADS,
  trialDuration: 30
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ADS_CAPACITY, {
  campaign: _campaigns.campaigns[ADS_CAPACITY],
  upgradeLink: links.addonAds,
  merchandiseId: MerchandiseIds.ADDON_ADS_CAPACITY
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, WEBSITE, {
  campaign: _campaigns.campaigns[WEBSITE],
  upgradeLink: links.addonWebsite,
  merchandiseId: MerchandiseIds.ADDON_WEBSITE_STARTER,
  trialDuration: 14
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, REPORTING, {
  campaign: _campaigns.campaigns[REPORTING],
  upgradeLink: links.addonReporting,
  merchandiseId: MerchandiseIds.ADDON_REPORTING,
  trialDuration: 10
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, DEDICATED_IP, {
  campaign: _campaigns.campaigns[DEDICATED_IP],
  upgradeLink: links.addonDedicatedIp,
  merchandiseId: MerchandiseIds.ADDON_DEDICATED_IP
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, TRANSACTIONAL_EMAIL, {
  campaign: _campaigns.campaigns[TRANSACTIONAL_EMAIL],
  upgradeLink: links.addonTransactionalEmail,
  merchandiseId: MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ADDITIONAL_ACCOUNT, {
  campaign: _campaigns.campaigns[ADDITIONAL_ACCOUNT],
  upgradeLink: links.addonAdditionalPortalLink,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, BRAND_DOMAIN, {
  campaign: _campaigns.campaigns[BRAND_DOMAIN],
  upgradeLink: links.addonBrandDomain,
  merchandiseId: MerchandiseIds.ADDON_BRAND_DOMAIN
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, DESIGNATED_TECHNICAL_SUPPORT, {
  campaign: _campaigns.campaigns[DESIGNATED_TECHNICAL_SUPPORT],
  upgradeLink: links.serviceDesignatedTechnicalSupport,
  merchandiseId: MerchandiseIds.SERVICE_DESIGNATED_TECHNICAL_SUPPORT
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, IN_PERSON_TRAINING, {
  campaign: _campaigns.campaigns[IN_PERSON_TRAINING],
  upgradeLink: links.serviceInPersonTraining,
  merchandiseId: MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONE_DAY
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, STARTER_KIT, {
  campaign: _campaigns.campaigns[STARTER_KIT],
  upgradeLink: links.serviceStarterKit,
  merchandiseId: MerchandiseIds.SERVICE_CRM_SALES_STARTER_KIT
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, QUICK_START_CONSULTATION, {
  campaign: _campaigns.campaigns[QUICK_START_CONSULTATION],
  upgradeLink: links.serviceQuickStartConsultation,
  merchandiseId: MerchandiseIds.SERVICE_QUICK_START_CONSULTATION
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SALES_PROFESSIONAL_ONBOARDING, {
  campaign: _campaigns.campaigns[SALES_PROFESSIONAL_ONBOARDING],
  upgradeLink: links.salesProfessionalOnboarding,
  merchandiseId: MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SERVICE_PROFESSIONAL_ONBOARDING, {
  campaign: _campaigns.campaigns[SERVICE_PROFESSIONAL_ONBOARDING],
  upgradeLink: links.serviceProfessionalOnboarding,
  merchandiseId: MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, INBOUND_CONSULTING_BLOCK, {
  campaign: _campaigns.campaigns[INBOUND_CONSULTING_BLOCK],
  upgradeLink: links.inboundConsultingBlock,
  merchandiseId: MerchandiseIds.SERVICE_INBOUND_CONSULTING_FOUR_HOUR
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, TECHNICAL_CONSULTING_BLOCK, {
  campaign: _campaigns.campaigns[TECHNICAL_CONSULTING_BLOCK],
  upgradeLink: links.technicalConsultingBlock,
  merchandiseId: MerchandiseIds.SERVICE_TECH_CONSULTING_FOUR_HOURS
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, CMS, {
  campaign: _campaigns.campaigns[CMS],
  upgradeLink: links.addonCms,
  merchandiseId: MerchandiseIds.ADDON_CMS
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, ENTERPRISE, {
  campaign: _campaigns.campaigns[ENTERPRISE],
  upgradeLink: links.marketingPricing,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, CRM, {
  campaign: _campaigns.campaigns[CRM],
  upgradeLink: links.addonCrm,
  merchandiseId: MerchandiseIds.PRODUCT_CRM
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, PARTNER_PROGRAM, {
  campaigns: _campaigns.campaigns[PARTNER_PROGRAM],
  upgradeLink: links.partnerProgramPaywall,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SUITE_STARTER, {
  campaigns: _campaigns.campaigns[SUITE_STARTER],
  upgradeLink: links.suite,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SUITE_PROFESSIONAL, {
  campaigns: _campaigns.campaigns[SUITE_PROFESSIONAL],
  upgradeLink: links.suite,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, SUITE_ENTERPRISE, {
  campaigns: _campaigns.campaigns[SUITE_ENTERPRISE],
  upgradeLink: links.suite,
  merchandiseId: null
}), (0, _defineProperty2.default)(_GENERAL$SALES_PRO$SA, BUNDLE, {
  campaigns: _campaigns.campaigns[BUNDLE],
  upgradeLink: links.bundle,
  merchandiseId: null
}), _GENERAL$SALES_PRO$SA);

exports.default = _default;
module.exports = exports.default;